import { Component, OnInit, OnDestroy, AfterViewInit, ChangeDetectorRef } from "@angular/core";
import { FormOfPaymentTypeSearchService } from "./form-of-payment-type-search.service";
import { Subscription } from "rxjs";
import { FormOfPaymentTypeSearchCriteria, FormOfPaymentTypeUpdateStatusCode } from "./form-of-payment-type-search.model";
import { FormOfPaymentTypeSearch } from "src/app/core/models/form-of-payment-model";
import { LoadingSpinnerService } from "src/app/shared/layout/loading-spinner";
import { ACTION_STATUS, ActionBarHandlerModel, ActionbarService } from "src/app/shared/ui/actionbar";
import { NewButtonModel, SaveButtonModel, CancelButtonModel, RefreshButtonModel } from "src/app/shared/ui/actionbar/models";
import { SecurityGroupService } from "src/app/core/services/system-services/security-group.service";
import { FormOfPaymentTypeSecurityCode } from "..";
import { NavigationService } from "src/app/shared/utils/navigation";
import { filter } from "rxjs/operators";
import { Router } from "@angular/router";

@Component({
    selector: 'op-form-of-payment-type-search',
    templateUrl: './form-of-payment-type-search.component.html',
})
export class FormOfPaymentTypeSearchComponent implements OnInit, OnDestroy, AfterViewInit {

    actionBarHandler = new ActionBarHandlerModel(
        new NewButtonModel(),
        new SaveButtonModel(),
        new CancelButtonModel(),
        new RefreshButtonModel(),
    )

    criteria: FormOfPaymentTypeSearchCriteria
    results: FormOfPaymentTypeSearch[]

    private subscriptions: Subscription[]

    constructor(private formOfPaymentTypeSearchService: FormOfPaymentTypeSearchService,
        private loadingSpinnerService: LoadingSpinnerService,
        private actionbarService: ActionbarService,
        private securityGroupService: SecurityGroupService,
        private navigateService: NavigationService,
        private cdr: ChangeDetectorRef,
        private router: Router) {
    }
    ngOnInit(): void {
        this.results = []
        this.subscriptions = []
        this.subscriptions.push(
            this.formOfPaymentTypeSearchService.callSearch$
                .pipe(
                    filter(flg => !!flg)
                )
                .subscribe(() => {
                    this.subscriptions.push(
                        this.formOfPaymentTypeSearchService.formOfPaymentTypes$.subscribe(formOfPaymentTypes => {
                            this.results = formOfPaymentTypes
                        })
                    )
                    this.subscriptions.push(
                        this.formOfPaymentTypeSearchService.loadStatusReference().subscribe()
                    )
                })
        )
        this.subscriptions.push(
            this.formOfPaymentTypeSearchService.refresh$
                .subscribe(() => {
                    this.search(this.criteria)
                })
        )
    }
    ngOnDestroy(): void {
        this.subscriptions.forEach(s => s.unsubscribe())
    }
    ngAfterViewInit(): void {
        this.setupActionBar()

        this.subscriptions.push(
            this.securityGroupService.userSecurityGroupSecurity
                .subscribe(userSecurities => {
                    const security = userSecurities.find(s => s.securityCode == FormOfPaymentTypeSecurityCode);

                    if (security) {
                        this.actionBarHandler.get(ACTION_STATUS.new).enable(security.newFlag);
                        this.actionbarService.updateState(this.actionBarHandler);
                    }
                })
        )
    }

    private setupActionBar() {
        this.actionBarHandler.get(ACTION_STATUS.new).enable(false);
        this.actionBarHandler.get(ACTION_STATUS.save).enable(false);
        this.actionBarHandler.get(ACTION_STATUS.cancel).enable(true);
        this.actionBarHandler.get(ACTION_STATUS.refresh).enable(true);
        this.actionbarService.updateState(this.actionBarHandler);
    }

    search(criteria: FormOfPaymentTypeSearchCriteria): void {
        if (criteria)
            this.criteria = criteria

        this.loadingSpinnerService.show()
        this.subscriptions.push(
            this.formOfPaymentTypeSearchService.getFormOfPaymentTypesSearch(this.criteria)
                .subscribe(() => {
                    this.loadingSpinnerService.hide()
                    this.cdr.markForCheck()
                },
                    () => this.loadingSpinnerService.hide())
        )
    }

    clear(): void {
        this.formOfPaymentTypeSearchService.clearSearch()
    }

    updateStatusCode(obj: FormOfPaymentTypeUpdateStatusCode): void {
        this.loadingSpinnerService.showSaving()
        this.subscriptions.push(
            this.formOfPaymentTypeSearchService.updateStatusCode(obj.formOfPaymentTypeCode, obj.statusCode)
                .subscribe(() => {
                    this.saveCompleteAndContinue(() => {
                        this.search(this.criteria)
                    })
                },
                    () => this.loadingSpinnerService.hide())
        )
    }

    private saveCompleteAndContinue(action) {
        this.loadingSpinnerService.saveComplete()
        setTimeout(() => {
            action()
        }, 1000);
    }

    navigateDetail(params) {
        this.formOfPaymentTypeSearchService.saveCriteria(this.router.url.split('/')[3], this.criteria)
        this.navigateService.navigate(`/main/settings/form-of-payment-type-detail`, null, false, params)
    }
}
